import "primereact/resources/themes/lara-light-blue/theme.css";  // theme
import "primereact/resources/primereact.min.css";                // core css
import "primeicons/primeicons.css";                              // icons
import 'primeflex/primeflex.css';
import "./global-overrides.scss"
import "./print-helpers.scss"

import PrimeReact from "primereact/api";

PrimeReact.zIndex.overlay = 10000;
